<div class="layout">
	<div
		class="sidebar"
		[class.collapsed]="!isExpanded"
		*embedded-view
	>
		@if (isExpanded) {
			<img
				ngSrc="/static/images/shared/logo-light.svg"
				height="36"
				width="133"
			/>
		} @else {
			<img
				ngSrc="/static/images/shared/logo-small-black.png"
				height="32"
				width="32"
			/>
		}
		<div class="menu-items">
			<div
				class="menu-item"
				*ngFor="let item of menuItems"
				[ngClass]="{ 'selected-route': selectedRoute.includes(item.route) }"
				[routerLink]="item.route"
				routerLinkActive="active"
			>
				<lib-icon [icon]="item.icon"></lib-icon>
				<span
					class="label"
					*ngIf="isExpanded"
					>{{ item.label }}</span
				>
			</div>
		</div>
	</div>

	<div class="main">
		<div
			class="topbar"
			*embedded-view
		>
			@if (isExpanded) {
				<lib-icon
					[hidden]="!isExpanded"
					[icon]="SidePanelClose"
					class="toggle-button"
					(click)="toggleSidebar()"
				>
				</lib-icon>
			} @else {
				<lib-icon
					[hidden]="isExpanded"
					[icon]="SidePanelOpen"
					class="toggle-button open"
					(click)="toggleSidebar()"
				>
				</lib-icon>
			}

			<app-header-nav style="width: 100%; height: 56px"></app-header-nav>
			@let user = userDetails$ | async;
			@let userTier = tier$ | async;
			@if (user && userTier) {
				<lib-profile-dropdown
					[username]="user.Username"
					[userTier]="userTier"
					[menuItems]="profileDropdownItems"
				></lib-profile-dropdown>
			} @else {
				<mat-progress-spinner
					diameter="20"
					mode="indeterminate"
				></mat-progress-spinner>
			}
		</div>
		<div class="content">
			<ng-content></ng-content>
		</div>
	</div>
</div>
